import { FC, ReactNode } from "react";
import "./StyledLink.scss";

interface Props {
  text: string;
  Image: ReactNode;
  url: string;
}

export const StyledLink: FC<Props> = (props) => {
  const onClick = () => {
    window.open(props.url, "_blank");
  };

  return (
    <div className="StyledLinkContainerWrapper">
      <div
        className="StyledLinkContainer"
        onClick={onClick}
        role="link"
        aria-label={`link to ${props.url}`}
      >
        <div className="StyledLinkImageContainer">{props.Image}</div>
        <div className="StyledLinkTextContainer">{props.text}</div>
      </div>
    </div>
  );
};
